var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPrinterIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "computer-printer 1",
    clipPath: "url(#clip0_654_40352)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M16.5004 17.2866H19.6433C20.06 17.2866 20.4597 17.121 20.7544 16.8263C21.0491 16.5316 21.2147 16.1319 21.2147 15.7151V8.64369C21.2147 8.22693 21.0491 7.82723 20.7544 7.53253C20.4597 7.23783 20.06 7.07227 19.6433 7.07227H2.35756C1.94079 7.07227 1.54109 7.23783 1.24639 7.53253C0.951694 7.82723 0.786133 8.22693 0.786133 8.64369V15.7151C0.786133 16.1319 0.951694 16.5316 1.24639 16.8263C1.54109 17.121 1.94079 17.2866 2.35756 17.2866H5.50042",
    stroke: "#555555",
    strokeWidth: 1.57143,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M5.5 14.9287V20.4287C5.5 20.6371 5.58278 20.8369 5.73013 20.9843C5.87748 21.1316 6.07733 21.2144 6.28571 21.2144H15.7143C15.9227 21.2144 16.1225 21.1316 16.2699 20.9843C16.4172 20.8369 16.5 20.6371 16.5 20.4287V14.9287H5.5Z",
    stroke: "#555555",
    strokeWidth: 1.57143,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M16.5 7.07185V1.57185C16.5 1.36346 16.4172 1.16361 16.2699 1.01626C16.1225 0.868913 15.9227 0.786133 15.7143 0.786133H6.28571C6.07733 0.786133 5.87748 0.868913 5.73013 1.01626C5.58278 1.16361 5.5 1.36346 5.5 1.57185V7.07185",
    stroke: "#555555",
    strokeWidth: 1.57143,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M17.2863 11H15.7148",
    stroke: "#555555",
    strokeWidth: 1.57143,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_654_40352"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrinterIcon);
export default __webpack_public_path__ + "static/media/printerIcon.2a1ed769b431d0fa632033248a3cb056.svg";
export { ForwardRef as ReactComponent };